@if (visible$ | async) {
  <div class="container">
    <div class="header">
      <span class="header-icon ph-duotone ph-chats-circle"></span>
      @let thread = threadHydratedId()!;
      <div class="header-center">
        @if (thread.item.title) {
          <span class="header-title">{{ thread.item.title }}</span>
        }
        @if (participantName$ | async; as name) {
          <div class="user-pill">
            <a class="alg-link user-pill-name" [routerLink]="{ id: participantId()!, isUser: true } | groupLink">
              {{ name }}
            </a>
          </div>
        } @else if (isOwnThreadWhileObserving$ | async) {
          <div class="user-pill own-thread" i18n>Your own thread</div>
        }
      </div>
      <div class="header-right">
        <button
          class="close-button size-s"
          type="button"
          icon="ph ph-x"
          alg-button-icon
          (click)="onClose()"
        ></button>
      </div>
    </div>
    <alg-thread class="thread"></alg-thread>
  </div>
}
